import React, { useState, useEffect } from 'react'
import { useDispatch } from 'react-redux'
import UpdateAddressModal from './UpdateAddressModal'
import DeleteAddressModal from './DeleteAddressModal'
import { FaEdit, FaTrash, FaMapMarkerAlt, FaPhone, FaGlobe, FaHome } from 'react-icons/fa'
import { Col, Row, Button, Card } from 'react-bootstrap'
import './AddressStyles.css'
import { COLORS } from '../../../constants/colors'

function Address({address = {}}) {
    const plum = COLORS.PLUM
    const sageGreen = COLORS.SAGE_GREEN
    const errorColor = COLORS.ERROR
        
    const [showUpdateModal, setShowUpdateModal] = useState(false)
    const [showDeleteModal, setShowDeleteModal] = useState(false)
    const [currentAddress, setCurrentAddress] = useState(address)

    const dispatch = useDispatch()

    // Ensure address state is updated when prop changes
    useEffect(() => {
        setCurrentAddress(address)
    }, [address])
    
    const updateModalShow = () => {
        setShowDeleteModal(false)
        setShowUpdateModal(true)
    }
    
    const updateModalClose = () => setShowUpdateModal(false)
    
    const deleteModalShow = () => {
        setShowUpdateModal(false)
        setShowDeleteModal(true)
    }
    
    const deleteModalClose = () => setShowDeleteModal(false)

    // Verify if the address has a valid ID
    const hasValidId = !!(currentAddress && currentAddress._id)
    
    return (
        <Card className="address-card p-3 h-100 shadow-sm">
            <div className="d-flex justify-content-end">
                <Button 
                    onClick={updateModalShow} 
                    className="edit"
                    disabled={!hasValidId}
                >
                    <FaEdit size={16} /> 
                </Button>
                <Button 
                    onClick={deleteModalShow} 
                    className="delete"
                    disabled={!hasValidId}
                >
                    <FaTrash size={16} /> 
                </Button>
            </div>
            <Row>
                <Col md={12}>
                    {/* Address Name */}
                    <div className="d-flex align-items-center mb-3">
                        <FaHome className="me-2" style={{ color: sageGreen }} />
                        <h5 className="mb-0" style={{ color: plum }}>
                            {currentAddress?.name || 'N/A'}
                        </h5>
                    </div>
                    
                    {/* Location: Province, District */}
                    <div className="d-flex align-items-center mb-2">
                        <FaMapMarkerAlt className="me-2" style={{ color: sageGreen }} />
                        <div>
                            {currentAddress?.district || 'N/A'}, {currentAddress?.province || 'N/A'} 
                            {currentAddress?.postalCode ? ` (${currentAddress.postalCode})` : ''}
                        </div>
                    </div>
                    
                    {/* Phone */}
                    <div className="d-flex align-items-center mb-2">
                        <FaPhone className="me-2" style={{ color: sageGreen }} />
                        <div>{currentAddress?.mobile || 'N/A'}</div>
                    </div>
                    
                    {/* Country */}
                    <div className="d-flex align-items-center">
                        <FaGlobe className="me-2" style={{ color: sageGreen }} />
                        <div>{currentAddress?.country || 'South Africa'}</div>
                    </div>
                </Col>
            </Row>

            {/* Only render modals if we have a valid address */}
            {hasValidId && (
                <>
                    <UpdateAddressModal
                        show={showUpdateModal}
                        onHide={updateModalClose}
                        addressData={{...currentAddress}}
                        dispatch={dispatch}
                    />

                    <DeleteAddressModal
                        show={showDeleteModal}
                        onHide={deleteModalClose}
                        addressData={{...currentAddress}}
                        dispatch={dispatch}
                    />
                </>
            )}
        </Card>
    )
}

export default Address